import { useRef } from 'react';

import { Dot } from './HostCursorDot.styled';

interface HostCursorDotProps {
  xRatio: number;
  yRatio: number;
  visible: boolean;
  containerWidth: number;
  containerHeight: number;
  slideAspectRatio: number;
}

export const HostCursorDot = ({
  xRatio,
  yRatio,
  visible,
  containerWidth,
  containerHeight,
  slideAspectRatio,
}: HostCursorDotProps) => {
  const lastPositionRef = useRef({ xRatio, yRatio, slideAspectRatio });

  if (visible) {
    lastPositionRef.current = { xRatio, yRatio, slideAspectRatio };
  }

  const {
    xRatio: effectiveX,
    yRatio: effectiveY,
    slideAspectRatio: effectiveAspect,
  } = lastPositionRef.current;

  const containerAspect = containerWidth / containerHeight;

  let renderedW: number;
  let renderedH: number;

  if (effectiveAspect > containerAspect) {
    // Slide is wider than container → letterbox top and bottom
    renderedW = containerWidth;
    renderedH = containerWidth / effectiveAspect;
  } else {
    // Slide is taller than container → letterbox left and right
    renderedH = containerHeight;
    renderedW = containerHeight * effectiveAspect;
  }

  const offsetX = (containerWidth - renderedW) / 2;
  const offsetY = (containerHeight - renderedH) / 2;

  const dotX = offsetX + effectiveX * renderedW;
  const dotY = offsetY + effectiveY * renderedH;

  return (
    <Dot
      $isVisible={visible}
      style={{
        transform: `translate(${dotX}px, ${dotY}px)`,
      }}
    />
  );
};
